import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import UserMainApp from "../../layouts/UserMainApp";
import EditAddress from "./EditAddress";
import DeleteAddress from "./DeleteAddress";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../redux/actions";
import PrimaryLoader from "../../includes/Loaders/PrimaryLoader";

export default function SingleAddressBook() {
  const { singleAddress, loading } = useSelector((state) => state.users);

  const dispatch = useDispatch();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");

  useEffect(() => {
    dispatch(userActions.getSingleAddress(id));
  }, [dispatch, id]);

  return (
    <UserMainApp>
      {loading ? (
        <PrimaryLoader />
      ) : (
        <div className="main-content-padding">
          <div className="main-content">
            <div className="d-flex justify-content-between mb-3">
              <h1 className="mr-2">Address Details</h1>
              <div className="d-flex gap-4 align-items-center">
                <EditAddress addressData={singleAddress?.data} />
                <DeleteAddress addressData={singleAddress?.data} />
              </div>
            </div>
            <div className="separator-breadcrumb border-top" />

            <div className="card">
              <div className="card-body">
                <div className="row mt-4">
                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">Title/Label</label>
                    <p className="text-dark small">
                      {singleAddress?.data?.title}
                    </p>
                  </div>

                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">Name</label>
                    <p className="text-dark small">
                      {singleAddress?.data?.name}
                    </p>
                  </div>

                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">
                      Street Address
                    </label>
                    <p className="text-dark small">
                      {singleAddress?.data?.address}
                    </p>
                  </div>

                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">City</label>
                    <p className="text-dark small">
                      {singleAddress?.data?.city}
                    </p>
                  </div>

                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">State</label>
                    <p className="text-dark small">
                      {singleAddress?.data?.state}
                    </p>
                  </div>

                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">Created On</label>
                    <p className="text-dark small">
                      {moment(singleAddress?.data?.created_at).format(
                        "Do MMM, YYYY"
                      )}
                    </p>
                  </div>

                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">
                      Delivery Instructions
                    </label>
                    <p className="text-dark small">
                      {singleAddress?.data?.description}
                    </p>
                  </div>

                  <div className="col-6 col-lg-2">
                    <label className="text-muted small mb-1">
                      Default Address
                    </label>
                    <p className="text-dark small">
                      {/* NGN {numberWithCommas(singleFood?.food_discount)} */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </UserMainApp>
  );
}
